import { Typography } from '@gds/Typography/Typography';

import PriceRatingGauge from '../PriceRatingGauge/PriceRatingGauge';
import type { priceRatingGaugeMessages } from '../PriceRatingGauge/PriceRatingGauge.messages';

import styles from './PriceRatingModal.module.css';

interface PriceRatingModalProps {
  strings: Record<keyof typeof priceRatingGaugeMessages, string>;
}

export const PriceRatingModal = ({ strings }: PriceRatingModalProps) => {
  return (
    <div className={styles.modalContent}>
      <Typography variant="body3" className={styles.modalIntro}>
        {strings.modalIntro}
      </Typography>

      <Typography variant="h6" className={styles.categoriesSubtitle}>
        {strings.categoriesSubtitle}
      </Typography>

      <div className={styles.categoryContainer}>
        <PriceRatingGauge rating="great" strings={strings} clickable={false} />
        <div className={styles.categoryText}>
          <Typography variant="body1" className={styles.subtitle}>
            {strings.greatPriceSubtitle}
          </Typography>
          <Typography variant="body3" className={styles.content}>
            {strings.greatPriceContent}
          </Typography>
        </div>
      </div>

      <div className={styles.categoryContainer}>
        <PriceRatingGauge rating="good" strings={strings} clickable={false} />
        <div className={styles.categoryText}>
          <Typography variant="body1" className={styles.subtitle}>
            {strings.goodPriceSubtitle}
          </Typography>
          <Typography variant="body3" className={styles.content}>
            {strings.goodPriceContent}
          </Typography>
        </div>
      </div>

      <div className={styles.categoryContainer}>
        <PriceRatingGauge rating="fair" strings={strings} clickable={false} />
        <div className={styles.categoryText}>
          <Typography variant="body1" className={styles.subtitle}>
            {strings.fairPriceSubtitle}
          </Typography>
          <Typography variant="body3" className={styles.content}>
            {strings.fairPriceContent}
          </Typography>
        </div>
      </div>
    </div>
  );
};
